import React from "react";
import Style from "./liveRegion.module.css";

/**
 * Permanently mounted polite live region. It must stay in the DOM for screen
 * readers to announce later changes, so the message is swapped rather than the
 * element being mounted and unmounted.
 *
 * role="status" is polite and never takes focus.
 */
const LiveRegion = ({ message }) => (
  <div className={Style.visuallyHidden} role="status" aria-live="polite">
    {message}
  </div>
);

export default LiveRegion;
